export default __webpack_public_path__ + "static/media/crypterium-wallet.35f24398.png";